'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Panels = require('../../main/jsx/Panels');

var _Panels2 = _interopRequireDefault(_Panels);

var _imagePanel = require('../../../../molecules/image-panel');

var _imagePanel2 = _interopRequireDefault(_imagePanel);

var _clone = require('../../../../../utilities/clone');

var _clone2 = _interopRequireDefault(_clone);

var _breakpoints = require('../../../../../utilities/breakpoints');

var _breakpoints2 = _interopRequireDefault(_breakpoints);

var _SlideNumberCarousel = require('./SlideNumberCarousel');

var _SlideNumberCarousel2 = _interopRequireDefault(_SlideNumberCarousel);

var _themeManager = require('../../utilities/themeManager');

var _themeManager2 = _interopRequireDefault(_themeManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ORGANISM_NAME = 'offer-panels';

var OfferPanels = function (_React$Component) {
  _inherits(OfferPanels, _React$Component);

  function OfferPanels(props) {
    _classCallCheck(this, OfferPanels);

    var _this = _possibleConstructorReturn(this, (OfferPanels.__proto__ || Object.getPrototypeOf(OfferPanels)).call(this, props));

    _this.panelsRef = null;
    _this.state = {
      isMobile: false,
      showImages: false
    };
    _this.handleResize = _this.handleResize.bind(_this);
    _this.handleScroll = _this.handleScroll.bind(_this);
    return _this;
  }

  _createClass(OfferPanels, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.handleResize);
      this.handleResize();
      var domRect = this.panelsRef && this.panelsRef.sectionElement ? this.panelsRef.sectionElement.getBoundingClientRect() : null;
      if (domRect && window.innerHeight - domRect.top >= 0) {
        this.enableImages();
        return;
      }
      window.addEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
      window.removeEventListener('resize', this.handleResize);
    }
  }, {
    key: 'enableImages',
    value: function enableImages() {
      this.setState({
        showImages: true
      });
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll() {
      window.removeEventListener('scroll', this.handleScroll);
      this.enableImages();
    }
  }, {
    key: 'handleResize',
    value: function handleResize(e) {
      var newWindowWidth = e && e.iFrameWidth || window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      if (newWindowWidth >= _breakpoints2.default.medium) {
        if (this.state.isMobile) {
          this.setState({
            isMobile: false
          });
        }
      } else if (!this.state.isMobile) {
        this.setState({
          isMobile: true
        });
      }
    }
  }, {
    key: 'renderPanels',
    value: function renderPanels(items, theme) {
      var _this2 = this;

      if (items) {
        return items.map(function (properties, idx) {
          var newProps = (0, _themeManager2.default)(properties, theme);
          if (!_this2.state.showImages) {
            newProps.content.image = null;
            newProps.content.icon = null;
            newProps.config = newProps.config || {};
            newProps.config.backgroundImage = {};
          }
          return _react2.default.createElement(
            'div',
            { key: idx },
            _react2.default.createElement(_imagePanel2.default, newProps)
          );
        });
      }
      return undefined;
    }
  }, {
    key: 'renderCarousel',
    value: function renderCarousel(isMobile, slides, theme, carouselContent, trackId) {
      var options = {
        startSlide: 0,
        speed: 400,
        className: ORGANISM_NAME,
        continuous: false
      };

      return _react2.default.createElement(
        'div',
        {
          key: slides.length,
          className: ORGANISM_NAME + '__wrapper'
        },
        _react2.default.createElement(
          _SlideNumberCarousel2.default,
          {
            className: ORGANISM_NAME + '__carousel',
            trackId: trackId || 'Offers-Carousel',
            options: options,
            content: carouselContent
          },
          this.renderPanels(slides, theme)
        )
      );
    }
  }, {
    key: 'renderByViewPort',
    value: function renderByViewPort(isMobile, props) {
      var config = props.config,
          content = props.content;
      var items = content.items,
          carousel = content.carousel;
      var theme = config.theme;


      if (isMobile) {
        return this.renderCarousel(isMobile, items, theme, carousel, props.trackId);
      }
      return this.renderPanels(items, theme);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      return _react2.default.createElement(
        _Panels2.default,
        _extends({}, this.props, { className: ORGANISM_NAME, ref: function ref(el) {
            _this3.panelsRef = el;
          } }),
        this.renderByViewPort(this.state.isMobile, this.props)
      );
    }
  }]);

  return OfferPanels;
}(_react2.default.Component);

exports.default = OfferPanels;


OfferPanels.propTypes = (0, _clone2.default)(_Panels2.default.propTypes);
OfferPanels.propTypes.trackId = _propTypes2.default.string.isRequired;

var items = [_imagePanel2.default.defaultProps, _imagePanel2.default.defaultProps, _imagePanel2.default.defaultProps, _imagePanel2.default.defaultProps];

OfferPanels.defaultProps = (0, _clone2.default)(_Panels2.default.defaultProps);
OfferPanels.defaultProps.content.items = items;
OfferPanels.defaultProps.content.carousel = {
  goToSlide: {
    text: 'Go to slide'
  },
  goToNextSlide: {
    text: 'Go to next slide'
  },
  goToPreviousSlide: {
    text: 'Go to previous slide'
  }
};
OfferPanels.defaultProps.config.theme = 'theme-background-color-white';
OfferPanels.defaultProps.config.type = 'ImagePanel';
OfferPanels.defaultProps.trackId = 'Offers-Carousel';
OfferPanels.defaultProps.config.deviceImage = undefined;


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/panels/offer-panels/jsx/OfferPanels.js
// module id = 1126
// module chunks = 4